<template>
  <div class="flightt" @click="getTripsType">
    <div class="">
      <div class="tab-pane animated fadeIn active show" id="tours">
        <div>
          <form>
          <!-- <form @submit.prevent="onSubmit"> -->
            <div class="flight-search-type flex flex-wrap" style="display: flex;">
              <div class="col-sm-6"      v-for="item in tripType"
                  :key="item.id">
                <div
                  class="form-check-inline"
             
                >
                  <label class="form-check-label">
                    <input
                      type="radio"
                      class="form-check-input"
                      :value="item.id"
                      v-model="selectedTripType"
                      @change="getTripType"
                    />
                    <span class="radio-title">{{ item.title }}</span>
                  </label>
                </div>
              </div>
            </div>

            <div class="row no-gutters custom-search-input-2">
              <div class="col-md-6">
                <div class="form-group">
                  <dropdown
                    :items="filteredOriginsList"
                    ref="origin"
                    itemText="persianName"
                    :placeholder="$t('HomeHeader.SearchSource')"
                    @onSelect="onSelectOrigin"
                    @onSearch="onSearchOrigin"
                  >
                    <template #start>
                      <i
                        class="icon icon_pin_alt"
                        :class="{ 'text-danger': $v.origin.$anyError }"
                      />
                    </template>
                    <template #noData>
                      <span>{{ $t("HomeHeader.NoCaseFound") }}</span>
                    </template>

                    <template v-slot:item="{ item }">
                      <div class="d-flex" style="color: black">
                        <div class="align-self-center pr-2">
                          <span
                            v-if="item.type == 'Airport'"
                            class="pl-2"
                          ></span>
                          <span
                            style="font-size: 24px; color: gray"
                            :class="{
                              'icon-airport': item.type == 'Airport',
                              icon_pin_alt: item.type == 'City',
                            }"
                          ></span>
                        </div>
                        <div class="align-self-stretch">
                          <span class="i-name">
                            <span v-if="item.type == 'Airport'">{{
                              $t("HomeHeader.Airport")
                            }}</span>
                            {{ item.persianName }} ({{ item.iata }})
                          </span>
                          <span
                            class="d-block"
                            style="font-size: 10px; color: gray"
                            v-if="item.type == 'City'"
                          >
                            {{ $t("HomeHeader.AllAirports") }}</span
                          >
                        </div>
                      </div>
                    </template>
                  </dropdown>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <dropdown
                    :items="filteredDestinationsList"
                    ref="destination"
                    itemText="persianName"
                    :placeholder="$t('HomeHeader.SearchDestination')"
                    @onSelect="onSelectDestination"
                    @onSearch="onSearchDestination"
                  >
                    <template #start>
                      <i
                        class="icon icon_pin_alt"
                        :class="{ 'text-danger': $v.destination.$anyError }"
                      />
                    </template>
                    <template #noData>
                      <span> {{ $t("HomeHeader.NoCaseFound") }}</span>
                    </template>

                    <template v-slot:item="{ item }">
                      <div class="d-flex" style="color: black">
                        <div class="align-self-center pr-2">
                          <span
                            v-if="item.type == 'Airport'"
                            class="pl-2"
                          ></span>
                          <span
                            style="font-size: 24px; color: gray"
                            :class="{
                              'icon-airport': item.type == 'Airport',
                              icon_pin_alt: item.type == 'City',
                            }"
                          ></span>
                        </div>
                        <div class="align-self-stretch">
                          <span class="i-name">
                            <span v-if="item.type == 'Airport'">{{
                              $t("HomeHeader.Airport")
                            }}</span>
                            {{ item.persianName }} ({{ item.iata }})
                          </span>
                          <span
                            class="d-block"
                            style="font-size: 10px; color: gray"
                            v-if="item.type == 'City'"
                          >
                            {{ $t("HomeHeader.AllAirports") }}
                          </span>
                        </div>
                      </div>
                    </template>
                  </dropdown>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <date-picker
                    :highlight="highlightFromDate"
                    popover="bottom-right"
                    auto-submit
                    :locale="loc"
                    ref="fromDate"
                    v-model="fromDate"
                    color="#00C3E1"
                    @change="onCheckInDateChange"
                    display-format="dddd jDD jMMMM"
                    format="jYYYY/jM/jD"
                    :placeholder="$t('HomeHeader.DepartureDate')"
                    name="departure-input"
                    :min="minFromDate"
                    :show="showCheckInDate"
                    @close="showCheckInDate = false"
                    @click="onCheckInClick"
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <date-picker
                    :disabled="returnDateValidation"
                    :class="{ 'disble-date-picker': returnDateValidation }"
                    color="#00C3E1"
                    popover="bottom-right"
                    :locale="loc"
                    display-format="jYYYY/jMM/jDD"
                    ref="toDate"
                    :highlight="highlightToDate"
                    :placeholder="$t('HomeHeader.ReturnDate')"
                    name="checkOut-input"
                    auto-submit
                    @change="onCheckOutDateChange"
                    format="jYYYY/jM/jD"
                    v-model="toDate"
                    :min="minToDate"
                    :show="showCheckOutDate"
                    @close="showCheckOutDate = false"
                    @click="onCheckOutClick"
                  >
                  </date-picker>
                </div>
              </div>

              <div class="col-md-12">
                <pdk-room :currentRooms="rooms" @roomChanged="onRoomChange" />
              </div>

              <div class="col-md-12">
                <input
                  type="submit"
                  style="font-size: 17px"
                  class="btn_search"
                  :value="$t('HomeHeader.Search')"
                />
              </div>
            </div>
          </form>

          <div class="entrance-alert">
            <transition name="fade"
              ><span v-if="$v.origin.$anyError" class="v-arrow v-top">
                {{ $t("HomeHeader.Source") }} {{ $t("HomeHeader.NotValid") }}
              </span></transition
            >
            <span v-if="!$v.origin.$anyError" class="col-lg-2"></span>
            <transition name="fade"
              ><span v-if="$v.destination.$anyError" class="v-arrow v-top">
                {{ $t("HomeHeader.Destination") }}
                {{ $t("HomeHeader.NotValid") }}
              </span></transition
            >
            <span v-if="!$v.destination.$anyError" class="col-lg-2"></span>
            <transition name="fade"
              ><span v-if="$v.fromDate.$anyError" class="v-arrow v-top">
                {{ $t("HomeHeader.DepartureDate") }}
                {{ $t("HomeHeader.NotValid") }}
              </span></transition
            >
            <span v-if="!$v.fromDate.$anyError" class="col-lg-2"></span>
            <transition name="fade">
              <span v-if="$v.toDate.$anyError" class="v-arrow v-top">
                {{ $t("HomeHeader.ReturnDate") }}
                {{ $t("HomeHeader.NotValid") }}
              </span>
            </transition>
            <span v-if="!$v.toDate.$anyError" class="col-lg-2"></span>
          </div>
          <transition name="fade">
            <div v-if="totalNight > 0" class="arrow top">
              {{ totalNight }} {{ $t("HomeHeader.StayNights") }}
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
import PdkRoom from "@/components/PdkRoom";
import dropdown from "@/components/PdkDropdown";
import PDKDateRange from "@/components/PdkDatePicker";
import flightSearchList from "@/components/flight/FlightSearchList";
import { required, requiredIf } from "vuelidate/lib/validators";
import moment from "moment";
import jalaaliMoment from "moment-jalaali";
import bi from "@/common/tour/baseInfoService";
import dateUtil from "../../utils/date";
import Store from "../../views/tour/store/index";
Vue.use(Vuelidate);
require("linqjs");

export default {
  store: Store,
  components: { PdkRoom, dropdown, PDKDateRange, flightSearchList },
  props: {
    selectedDestination: { type: Object },
    selectedHotel: { type: Object },
    originList: Object,
    destinationList: Array,
  },

  data: () => ({
    birthday: "1987-10-04 00:00:00",
    showCheckInDate: false,
    showCheckOutDate: false,
    rooms: [],
    now: moment(),
    origin: null,
    destination: null,
    originName: "",
    destinationName: "",
    fromDate: "",
    minFromDate: "",
    minToDate: "",
    maxFromDate: "",
    toDate: "",
    filteredOriginsList: [],
    filteredDestinationsList: [],
    returnDateValidation: true,
    totalNight: 0,
    loc: "",
    tripType: [
      { id: 1, title: "یک طرفه" },
      { id: 2, title: "رفت و برگشت" },
    ],
    selectedTripType: 1,
  }),
  computed: {
    getTripsType: function () {
      this.getLanguage();
      const locc = this.loc;
      return this.tripType.filter(function (id) {
        if (locc == "fa") {
          if (id.title == "یک طرفه" || id.title == "One Way") {
            id.title = "یک طرفه";
          }
          if (id.title == "رفت و برگشت" || id.title == "Roundtrip") {
            id.title = "رفت و برگشت";
          }
        } else {
          if (id.title == "یک طرفه" || id.title == "One Way") {
            id.title = "One Way";
          }
          if (id.title == "رفت و برگشت" || id.title == "Roundtrip") {
            id.title = "Roundtrip";
          }
        }
      });
    },
  },
  watch: {
    selectedDestination: function (val) {
      if (val !== null) {
        this.$refs.destination.selectItem(val);
        // this.$refs.destination.selectItem(val);
        //  selected-dest
        this.$refs.origin.$el.classList.add("active");
        this.$refs.destination.$el.classList.remove("focused-hotel-location");
        this.$refs.destination.$el.classList.add("focused-dest-location");

        this.$refs.origin.$refs.input.focus();
      }
    },
    selectedHotel: function (val) {
      if (val !== null) {
        this.$refs.destination.selectItem(val);
        // this.$refs.destination.selectItem(val);
        //  selected-dest
        this.$refs.origin.$el.classList.add("active");
        this.$refs.destination.$el.classList.remove("focused-dest-location");
        this.$refs.destination.$el.classList.add("focused-hotel-location");

        this.$refs.origin.$refs.input.focus();
      }
    },
    fromDate: function (val) {
      if (val !== null) {
        this.fromDate = val;
      }
    },
    originList(val) {
      this.filteredOriginsList = val.data.filter(() => true);
      // this.filteredDestinationsList = val.filter(() => true);
    },
    destinationList(val) {
      this.filteredDestinationsList = val.filter(() => true);
    },
  },
  validations: {
    origin: {
      required,
      checkLocation: function (val) {
        return this.origin != this.destination;
      },
    },
    destination: {
      required,
      checkLocation: function (val) {
        return this.origin != this.destination;
      },
    },
    rooms: {
      required,
    },
    fromDate: {
      required,
      // checkDate: function (val) {
      //   var diff = moment(this.toDate).diff(moment(val), "days");
      //   return diff > 0;
      // },
    },
    toDate: {
      required: requiredIf(function () {
        return !this.returnDateValidation;
      }),
      checkDate: function (val) {
        if (this.returnDateValidation) return true;
        else {
          var diff = moment(val).diff(moment(this.fromDate), "days");
          return diff > 0;
        }
      },
    },
  },

  methods: {
    highlightFromDate(formatted, dateMoment, checkingFor) {
      const selectedToDate = this.toDate;

      let attributes = { title: "Today is " + formatted };
      if (checkingFor === "day" && formatted === selectedToDate) {
        attributes["class"] = "highlighted-date";
        attributes["title"] = "تاریخ برگشت";
        attributes["style"] =
          "color: white;border-radius: 50%;background: rgb(65 125 244);font-size: 15px;";
      }

      return attributes;
    },
    getLanguage() {
      this.loc = this.$i18n.locale;
      return this.loc;
    },
    highlightToDate(formatted, dateMoment, checkingFor) {
      const selectedFromDate = this.fromDate;

      let attributes = { title: "Today is " + formatted };
      if (checkingFor === "day" && formatted === selectedFromDate) {
        attributes["class"] = "highlighted-date";
        attributes["title"] = "تاریخ رفت";
        attributes["style"] =
          "color: white;border-radius: 50%;background: rgb(65 125 244);font-size: 15px;";
      }

      return attributes;
    },
    calculateTotalNight() {
      this.totalNight = 0;
      if (
        this.fromDate != "" &&
        this.fromDate != null &&
        this.toDate != "" &&
        this.toDate != null
      ) {
        let fDate = jalaaliMoment(this.fromDate, "jYYYY/jMM/jDD").format(
          "YYYY/MM/DD"
        );
        let tDate = jalaaliMoment(this.toDate, "jYYYY/jMM/jDD").format(
          "YYYY/MM/DD"
        );

        var startDate = moment(fDate);
        var endDate = moment(tDate);
        let duration = moment.duration(endDate.diff(startDate));

        let diff = Math.round(duration.asDays());

        // var diff = moment(tDate).diff(moment(fDate), "days");

        // var diff = moment(this.toDate).diff(moment(this.fromDate), "days");
        this.totalNight = diff;
      } else {
        this.totalNight = 0;
      }
    },

    calculateMinToDate() {
      this.showCheckOutDate = true;
      if (this.minFromDate == "" || this.minToDate == null) {
        const currentDate = new Date();
        this.minToDate = dateUtil.ConvertToPersian(currentDate);
      } else {
        this.minToDate = jalaaliMoment(this.fromDate, "jYYYY/jM/jD").format(
          "jYYYY/jMM/jDD"
        );
      }
    },
    onCheckInDateChange() {
      setTimeout(() => (this.showCheckOutDate = true), 500);
      this.showCheckOutDate = true;
      this.calculateMinToDate();
      this.calculateTotalNight();

      if (this.toDate !== "") {
        this.maxFromDate = jalaaliMoment(this.toDate, "jYYYY/jM/jD").format(
          "jYYYY/jMM/jDD"
        );
      } else {
        this.maxFromDate = "";
      }
    },
    onCheckOutDateChange() {
      this.calculateTotalNight();
    },
    onCheckInClick() {
      this.calculateTotalNight();

      this.showCheckInDate = true;

      const currentDate = new Date();
      this.minFromDate = dateUtil.ConvertToPersian(currentDate);
      if (this.toDate !== "") {
        this.maxFromDate = jalaaliMoment(this.toDate, "jYYYY/jM/jD").format(
          "jYYYY/jMM/jDD"
        );
      } else {
        this.maxFromDate = "";
      }
    },
    onCheckOutClick() {
      this.showCheckOutDate = true;
      if (this.minFromDate == "" || this.minToDate == null) {
        const currentDate = new Date();
        this.minToDate = dateUtil.ConvertToPersian(currentDate);
      } else {
        this.minToDate = jalaaliMoment(this.fromDate, "jYYYY/jM/jD").format(
          "jYYYY/jMM/jDD"
        );
      }
    },
    onRoomChange(rooms) {
      this.rooms = rooms;
    },

    onSearchOrigin(search) {
      if (typeof search === "undefined") search = "".toString();

      search = search.toString().toLowerCase().trim();

      if (
        typeof this.originList.data !== undefined &&
        this.originList.data.length <= 0
      ) {
        this.filteredOriginsList = [];
        return;
      }

      if (search.trim() === "" || search.length < 3) {
        this.filteredOriginsList = this.originList.data.sort((t) => t.order);
        return;
      }

      this.filteredOriginsList = this.originList.data
        .filter(
          (t) =>
            t.englishName.toString().toLowerCase().includes(search) ||
            t.persianName.toString().toLowerCase().includes(search) ||
            t.iata.toString().toLowerCase().includes(search) ||
            t.tags.any((x) =>
              x.toString().trim().toLowerCase().includes(search)
            )
        )
        .sort((t) => t.order);
    },

    onSearchDestination(search) {
      if (typeof search === "undefined") search = "".toString();

      search = search.toString().toLowerCase().trim();

      if (
        typeof this.destinationList !== undefined &&
        this.destinationList.length <= 0
      ) {
        this.filteredDestinationsList = [];
        return;
      }

      if (search.trim() === "" || search.length < 3) {
        this.filteredDestinationsList = this.destinationList.sort(
          (t) => t.englishName
        );
        return;
      }

      this.filteredDestinationsList = this.destinationList
        .filter(
          (t) =>
            t.englishName.toString().toLowerCase().includes(search) ||
            t.persianName.toString().toLowerCase().includes(search) ||
            t.iata.toString().toLowerCase().includes(search) ||
            t.tags.any((x) =>
              x.toString().trim().toLowerCase().includes(search)
            )
        )
        .sort((t) => t.order);
    },

    onSubmit() {
      this.$v.$touch();
      this.$refs.origin.validate();
      this.$refs.destination.validate();

      if (this.$v.$invalid) return;
      // var searchedItem = {
      //   origin: this.origin,
      //   destination: this.destination,
      //   originName: this.originName,
      //   destinationName: this.destinationName,
      //   fromDate: this.fromDate,
      //   toDate: this.toDate,
      //   rooms: this.rooms,
      // };
      // this.$store.dispatch("Base/Searcheditems", searchedItem);

      this.$router
        .push({
          name: "flightSearch",
          query: {
            origin: this.origin,
            destination: this.destination,
            originName: this.originName,
            destinationName: this.destinationName,
            fromDate: jalaaliMoment(this.fromDate, "jYYYY/jM/jD").format(
              "YYYY/MM/DD"
            ),
            toDate: jalaaliMoment(this.toDate, "jYYYY/jM/jD").format(
              "YYYY/MM/DD"
            ),
            rooms: JSON.stringify(this.rooms),
          },
        })
        .catch(() => {});
    },
    getTripType() {
      if (this.selectedTripType === 1) {
        this.returnDateValidation = true;
        this.toDate = null;
      } else this.returnDateValidation = false;
    },

    onSelectOrigin(item) {
      this.origin = item?.iata;
      this.originName = item?.persianName;
    },

    onSelectDestination(item) {
      this.destination = item?.iata;
      this.destinationName = item?.persianName;
    },

    loadFromRoute() {
      const params = this.$route.query;

      const filter = function (item, search) {
        return item.iata.toLowerCase().trim() == search;
      };

      if (params.origin) {
        const search = params.origin.toLowerCase().trim();
        const items = this.originList.data.filter(
          (item) => item.iata.toLowerCase().trim() == search
        );

        if (Array.isArray(items) && items.length > 0) {
          this.$refs.origin.selectItem(items[0]);
        }
      }

      if (params.destination) {
        const search = params.destination.toLowerCase().trim();
        const items = this.destinationList.filter(
          (item) => item.iata.toLowerCase().trim() == search
        );

        if (Array.isArray(items) && items.length > 0) {
          this.$refs.destination.selectItem(items[0]);
        }
      }

      if (params.fromDate && params.fromDate.trim() != "")
        this.fromDate = jalaaliMoment(params.fromDate, "YYYY/MM/DD").format(
          "jYYYY/jMM/jDD"
        );

      if (params.toDate && params.toDate.trim() != "")
        this.toDate = jalaaliMoment(params.toDate, "YYYY/MM/DD").format(
          "jYYYY/jMM/jDD"
        );
      if (parseInt(params.tripType) === 1) {
        this.selectedTripType = 2;
        this.returnDateValidation = false;
        this.toDate = null;
      } else {
        this.returnDateValidation = true;
        this.selectedTripType = 1;
      }
    },
  },

  async created() {
    this.destination = this.selectedDestination;
    const currentDate = new Date();
    this.minFromDate = dateUtil.ConvertToPersian(currentDate);
    // const currentDate = dateUtil.ConvertToPersian(new Date());
    // this.fromDate = currentDate;
    // this.toDate = dateUtil.AddPersian(currentDate,"day",1);
  },
  async mounted() {
    this.isMounted = true;

    // this.filteredOriginsList = this.originList.data.filter(() => true);
    // this.filteredDestinationsList = this.destinationList.filter(() => true);

    // if (this.destinationList.length > 0)
    //   this.$refs.destination.selectItem(this.destinationList[0]);

    this.loadFromRoute();
  },
};
</script>
<style lang="scss" scoped>
.flight-search-type {
  background-color: rgba(255, 255, 255, 0.88);
  padding-top: 15px;
  padding-bottom: 15px;
}

.form-check-inline {
  padding-left: 12px;
}

.btn_tab {
  width: 115px;
  height: 55px;
  text-align: center;
  background: #b4b3b3;
  color: #fefefe;
  border-radius: 6px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 6px;
  padding-bottom: 6px;
  font-size: 14px;
}

.btn_tab:hover {
  background: #eeb61f;
}

.btn_tab div {
  font-size: 16px;
  text-align: center;
}

@media only screen and (min-width: 768px) {
  .col-md-2 {
    flex: 0 0 13.666% !important;
    max-width: 13.93% !important;
  }
}

@media screen and (min-width: 768px) {
  .col-md-3 {
    flex: 0 0 21% !important;
    max-width: 21% !important;
  }
}

@media (min-width: 768px) {
  .col-md-1 {
    flex: 0 0 17%;
    max-width: 17%;
  }
}

.search-title {
  text-align: center;
  margin-bottom: 4%;
  margin-top: 7%;
}

.search-title h2 {
  color: whitesmoke;
}

.search-box {
  background: rgba(4, 58, 84, 0.8);
  padding: 2%;
  border-radius: 10px;
  margin-bottom: 15px;
}

.highlighted-date .vpd-day-text {
  color: #ef6c00 !important;
}

// .vpd-day-effect {
//   background-color: #f9e1be !important;
//   border: solid 1px #EF6C00;
// }

.arrow {
  position: absolute;
  left: 10%;
  top: 60%;
  text-align: center;
  padding: 5px 8px;
  padding-top: 8px;
  padding-bottom: 8px;
  background: #00c3e1;
  color: #ffffff;
  font-size: 14px;
}

.arrow::after {
  content: "";
  position: absolute;
  top: 0;
  width: 0;
  height: 0;
}

.v-arrow {
  margin-top: 19px;
  max-width: auto;
  /* min-width: 200px; */
  margin-left: 1%;
  /* margin-right: auto; */
  position: -webkit-sticky;
  position: sticky;
  /* margin: 10px; */
  border-radius: 7px;
  text-align: center;
  padding-top: 8px;
  padding-bottom: 8px;
  background: #f95379;
  color: #ffffff;
  font-size: 12px;
}

.v-arrow::after {
  content: "";
  position: absolute;
  top: 0;
  width: 0;
  height: 0;
}

.v-top::after {
  right: -17px;
  top: 6px;
  border-width: 9px;
  border-color: transparent transparent transparent #f95379;
  border-style: solid;
}

.top::after {
  right: -17px;
  top: 6px;
  border-width: 9px;
  border-color: transparent transparent transparent #00c3e1;
  border-style: solid;
}

.custom-date-icon:hover {
  cursor: pointer;
  color: #365ab2;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

#custom-radio-buttons .radio-wrapper {
  display: inline-block;
}

#custom-radio-buttons .radio-wrapper input[name="custom-radio"] {
  display: none;
}

#custom-radio-buttons .radio-wrapper input[name="custom-radio"] + label {
  color: #292321;
  font-size: 14px;
  font-weight: 500;
  padding-left: 32px;
  padding-bottom: 10px;
  padding-top: 15px;
}

#custom-radio-buttons
  .radio-wrapper
  input[name="custom-radio"]
  + label
  > span.outer {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin: -1px 4px 0 0;
  border: 2px solid #cccccc;
  vertical-align: middle;
  cursor: pointer;
  position: relative;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background-color: #f8f8f8;
}

#custom-radio-buttons
  .radio-wrapper
  input[name="custom-radio"]
  + label
  span.inner {
  display: block;
  position: absolute;
  display: none;
  width: 10px;
  height: 10px;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  vertical-align: middle;
  cursor: pointer;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background-color: grey;
}
.radio-title{
  padding:  0 6px;
}
#custom-radio-buttons
  .radio-wrapper
  input[name="custom-radio"]:checked
  + label
  span.inner {
  background-color: #3c5eb2;
  display: block;
}

.disble-date-picker {
  opacity: 0.4;
}
</style>